/**
 * Date object util function. Takes the month value from the Date getMonth function, adding a '0' at the start if < 10
 *
 * @param month number. value from Date getMonth, which needs to be adjusted first since the months are returned as
 * values from 0 to 11 instead of 1-12. Hence, the +1 adjustment on the month.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getMonth
 */
export const addZeroAtStartMonth = (month: number): string => String(month + 1).padStart(2, '0');

export const addZeroAtStartDay = (day: number): string => String(day).padStart(2, '0');
